import {AppClient} from "./client";

export const environment = {
  onlyOfficeServerUrl: AppClient.OPENOFFICE_URL_QA,
  production: true,
  baseUrl: '/app',
  baseUrlws: '/sock',
  videoFeedApi: '/videoFeed',
  videoMergeFeed: '/videoMerge',
  gpuProctoringUrl: '/gpu',
  gpuQueueStatusUrl: '/proctorQueue',
  videoProctoringMachineId: '84065140264278613',
  VAPI_INTERVIEW_AGENT_ASSISTANT_ID: '3c592f00-d49a-470a-b241-a0f99379b6c5',
  VAPI_INTERVIEW_AGENT_LATERAL_ASSISTANT_ID:
    '47f149ae-38b9-4d55-9ac9-e18494cc0cc9',
  VAPI_INTERVIEW_AGENT_IMAGINEER_ASSISTANT_ID:
    '3c592f00-d49a-470a-b241-a0f99379b6c5',
  VAPI_INTERVIEW_AGENT_PRACTICE_ASSISTANT_ID:
    '3e761da4-d842-46d0-b612-017ce3768896',
  VAPI_INTERVIEW_AGENT_DEBRIEF_ASSISTANT_ID:
    '1d5ae480-bd9f-4ad5-854a-d0e218ff870c',
  VAPI_INTERVIEW_AGENT_DETAILED_PRACTICE_ASSISTANT_ID:
    '2959b8d1-7e6c-4a01-b905-161c50a99b63',  
  VAPI_JD_BOT_ASSISTANT_ID: 'c0732b33-5e6c-4cae-a082-ebb0b43bd719',
  DOWNLOADAPP: 'https://f360.foyr.com/app-entry-page',
  DESKTOP_IQIGAI_LITE: false,
  STATIC_OTP: 123456,

  deployedClient: AppClient.LOCAL_MAIN,

  appUrl : AppClient.URL_LOCAL_MAIN,
  enableSentry: true
};
